import React from 'react';
import SharedHeader from '../../shared/Header';
import navbarData from '../../data/Navbar/navbar';

const logo = require('../../assets/img/code_me_up_logo.png');

const Header = () => (
  <SharedHeader
    navItems={navbarData}
    logoSrc={logo}
    contactHref="/contact"
    contactIsExternal={false}
    homeTo="/"
  />
);

export default Header;
